export default __webpack_public_path__ + "static/media/cuciReloadFaq2.2a3b1d9e.png";